export default args => {
  const queryArg = args.ids
    ? `ids: [${args.ids.join(',')}]`
    : args.skus
      ? `skus: ${JSON.stringify(args.skus)}`
      : ''

  return `
    {
      filterPageItems(${queryArg}) {
        id
        name
        summary
        mainVariantId
        displayedVariantId
        price
        filterValues

        variants {
          id
          colorName
          productUrl
          imageUrl
          backgroundImageUrl
          backgroundVideoUrl
          colorCodePrimary
          colorCodeSecondary
          skus
          productData
          filterValues
        }
      }
    }
  `
}
